import React from 'react'
import { CFooter } from '@coreui/react'

const AppFooter = () => {
  return (
    <CFooter>
      <div>
        <a href="https://www.innovotecnologias.com.ar" target="_blank" rel="noopener noreferrer">
          Suite Vendedores WebApp
        </a>
        <span className="ms-1">&copy; 2024 Innovo</span>
      </div>
      <div className="ms-auto">
        <span className="me-1">Basado en CoreUI</span>
      </div>
    </CFooter>
  )
}

export default React.memo(AppFooter)
